import {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useState
} from 'react';

type FieldState<T> = readonly [T, Dispatch<SetStateAction<T>>];

// Transient widget UI state is lifted into the Filters drawer so it can be
// reset from a single place when the drawer closes, instead of relying on the
// widgets being unmounted (which is no longer the case for performance).
// Two separate contexts keep typing in the region search from re-rendering the
// expensive category tree, and vice versa.
export const RegionQueryContext = createContext<FieldState<string> | null>(
  null
);

export const ExpandedCategoryContext = createContext<FieldState<string> | null>(
  null
);

// Region search text. Falls back to component-local state when the widget is
// rendered outside the filters drawer (e.g. RegionModalMobile), so reuse stays
// self-contained.
export const useRegionQueryState = (): FieldState<string> => {
  const local = useState('');
  return useContext(RegionQueryContext) ?? local;
};

// Currently expanded category id. Falls back to component-local state when used
// outside the filters drawer (e.g. CategoryModal).
export const useExpandedCategoryState = (): FieldState<string> => {
  const local = useState('');
  return useContext(ExpandedCategoryContext) ?? local;
};
